module.exports = __webpack_public_path__ + "img/zero-illu-01.fcf62379.svg";